<app-nav-bar></app-nav-bar>
<main>
  <!-- <app-book-ameeting-modal></app-book-ameeting-modal> -->
  <app-toast></app-toast>
  <router-outlet #outlet="outlet"></router-outlet>
</main>
<app-footer></app-footer>
